import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/order';

export default function Order() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
